/* Mores Couture theme script */
(function () {
  'use strict';
  if (window.__mcInit) return;
  window.__mcInit = true;

  var MC = window.MC || { routes: { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', root: '/' }, money: '{{amount}}', strings: {} };
  var S = MC.strings || {};
  var root = (MC.routes.root || '/').replace(/\/$/, '');
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || MC.money || '{{amount}}';
    function delim(n, prec, thou, dec) {
      thou = thou === undefined ? ',' : thou; dec = dec === undefined ? '.' : dec;
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(prec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thou);
      return d + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var v = '';
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': v = delim(cents, 0); break;
      case 'amount_with_comma_separator': v = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = delim(cents, 2, "'", '.'); break;
      default: v = delim(cents, 2);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  /* ---------- toast ---------- */
  var toastEl, toastT;
  function toast(msg, withLink) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'mc mc-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span></span>' + (withLink ? '<a href="' + MC.routes.cart + '">' + (S.view || 'View bag') + '</a>' : '');
    toastEl.firstChild.textContent = msg;
    toastEl.classList.add('is-show');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-show'); }, 3500);
  }

  /* ---------- cart helpers ---------- */
  function setCartCount(n) {
    $$('[data-mc-cart-count]').forEach(function (el) { el.textContent = n > 0 ? n : ''; el.setAttribute('data-count', n); });
  }
  function refreshCount() {
    return fetch(root + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCartCount(c.item_count); return c; });
  }
  function addToCart(id, qty) {
    return fetch(MC.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || j.status) throw new Error(j.description || j.message || S.error);
        return j;
      });
    });
  }

  /* ---------- mobile drawer ---------- */
  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mc-drawer-open]');
    if (open) {
      var d = $('[data-mc-drawer]');
      if (d) {
        d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
        if (open.classList.contains('mc-msearch')) { var i = $('input[type=search]', d); if (i) setTimeout(function () { i.focus(); }, 300); }
      }
    }
    if (e.target.closest('[data-mc-drawer-close]')) {
      var d2 = $('[data-mc-drawer]');
      if (d2) { d2.classList.remove('is-open'); d2.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
    }
  });

  /* close currency / filter dropdowns on outside click */
  document.addEventListener('click', function (e) {
    $$('details.mc-curr[open], details[data-mc-fd][open]').forEach(function (d) {
      if (!d.contains(e.target)) d.removeAttribute('open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('details.mc-curr[open], details[data-mc-fd][open]').forEach(function (d) { d.removeAttribute('open'); });
    closeQuick();
    var d2 = $('[data-mc-drawer].is-open');
    if (d2) { d2.classList.remove('is-open'); document.body.style.overflow = ''; }
  });
  document.addEventListener('toggle', function (e) {
    var t = e.target;
    if (t.matches && t.matches('details[data-mc-fd]') && t.open) {
      $$('details[data-mc-fd][open]').forEach(function (d) { if (d !== t) d.removeAttribute('open'); });
    }
  }, true);

  /* ---------- tabs ---------- */
  function initTabs(scope) {
    $$('[data-mc-tabs]', scope).forEach(function (sec) {
      if (sec.__mc) return; sec.__mc = true;
      var tabs = $$('[data-mc-tab]', sec);
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          var id = t.getAttribute('data-mc-tab');
          tabs.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on); });
          $$('[data-mc-panel]', sec).forEach(function (p) { p.hidden = p.getAttribute('data-mc-panel') !== id; });
        });
      });
    });
  }

  /* ---------- gallery dots ---------- */
  function initGallery(scope) {
    $$('[data-mc-gallery]', scope).forEach(function (sec) {
      if (sec.__mc) return; sec.__mc = true;
      var track = $('[data-mc-gal-track]', sec), dots = $('[data-mc-gal-dots]', sec);
      if (!track || !dots) return;
      var items = track.children; var n = items.length;
      if (n < 2) return;
      for (var i = 0; i < n; i++) {
        (function (k) {
          var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to image ' + (k + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: items[k].offsetLeft - track.offsetLeft - parseInt(getComputedStyle(track).paddingLeft || 0), behavior: 'smooth' }); });
          dots.appendChild(b);
        })(i);
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth;
        var idx = max > 0 ? Math.round((track.scrollLeft / max) * (n - 1)) : 0;
        $$('button', dots).forEach(function (b, k) { b.classList.toggle('is-active', k === idx); });
      }
      track.addEventListener('scroll', update, { passive: true });
      update();
    });
  }

  /* ---------- collection filters ---------- */
  function submitFilters(form) {
    var fd = new FormData(form); var params = new URLSearchParams();
    fd.forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
    var url = form.getAttribute('action') + (params.toString() ? '?' + params.toString() : '');
    window.location.href = url;
  }
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-mc-auto]')) {
      var f = e.target.closest('form[data-mc-filter-form]');
      if (f) submitFilters(f);
    }
  });
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-mc-filter-form]');
    if (f) { e.preventDefault(); submitFilters(f); }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-mc-top]')) window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* ---------- wishlist ---------- */
  var WKEY = 'mc_wishlist';
  function wlGet() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function wlSet(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function wlPaint() {
    var list = wlGet();
    $$('[data-mc-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-mc-wish')) > -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on);
      if (b.hasAttribute('data-mc-wish-text')) { var s = $('span', b); if (s) s.textContent = on ? (b.getAttribute('data-wl-on') || 'Added to Wishlist') : (b.getAttribute('data-wl-add') || 'Add to Wishlist'); }
    });
    $$('[data-mc-wish-count]').forEach(function (c) { c.textContent = list.length ? list.length : ''; c.setAttribute('data-count', list.length); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mc-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-mc-wish'); var list = wlGet(); var i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else list.unshift(h);
    wlSet(list); wlPaint();
    var page = $('[data-mc-wishlist-page]');
    if (page && i > -1) { var card = b.closest('.mc-card'); if (card) card.remove(); if (!wlGet().length) { var em = $('[data-mc-wl-empty]', page); if (em) em.hidden = false; } }
  });
  function initWishlistPage() {
    var page = $('[data-mc-wishlist-page]'); if (!page || page.__mc) return; page.__mc = true;
    var grid = $('[data-mc-wl-grid]', page), empty = $('[data-mc-wl-empty]', page);
    var list = wlGet();
    if (!list.length) { empty.hidden = false; return; }
    Promise.all(list.map(function (h) {
      return fetch(root + '/products/' + encodeURIComponent(h) + '?view=mc-card').then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; });
    })).then(function (htmls) {
      var keep = [];
      htmls.forEach(function (html, k) { if (html && html.indexOf('mc-card') > -1) { grid.insertAdjacentHTML('beforeend', html); keep.push(list[k]); } });
      wlSet(keep); wlPaint();
      if (!keep.length) empty.hidden = false;
    });
  }

  /* ---------- variant logic (shared by product page and quick add) ---------- */
  function findVariant(product, selected) {
    return product.variants.find(function (v) {
      return v.options.every(function (o, i) { return selected[i] === undefined || selected[i] === null || o === selected[i]; });
    });
  }
  /* strict = every other selected option must match (used for sizes: "available in this colour") */
  function valueAvailable(product, selected, idx, value, strict) {
    return product.variants.some(function (v) {
      if (!v.available || v.options[idx] !== value) return false;
      return v.options.every(function (o, i) { return i === idx || (!strict && i > idx) || selected[i] == null || o === selected[i]; });
    });
  }

  /* ---------- product page ---------- */
  function initProduct(scope) {
    $$('[data-mc-product-section]', scope).forEach(function (sec) {
      if (sec.__mc) return; sec.__mc = true;
      var jsonEl = $('[data-mc-product-json]', sec); if (!jsonEl) return;
      var product = JSON.parse(jsonEl.textContent);
      var idInput = $('[data-mc-variant-id]', sec);
      var current = product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];
      var selected = current ? current.options.slice() : [];
      var addBtn = $('[data-mc-add]', sec), priceEl = $('[data-mc-price]', sec), err = $('[data-mc-error]', sec);
      var sizeIdx = -1;
      product.options.forEach(function (n, i) { if (/size|مقاس|قياس|حجم/i.test(n)) sizeIdx = i; });
      var sizeChosen = sizeIdx === -1 || /[?&]variant=/.test(location.search) || product.variants.length === 1;

      /* gallery */
      var main = $('[data-mc-main]', sec), tlist = $('[data-mc-tlist]', sec);
      function showMedia(id) {
        if (!id || !main) return;
        var img = $('img[data-media-id="' + id + '"]', main); if (!img) return;
        $$('img', main).forEach(function (i) { i.classList.toggle('is-active', i === img); if (i === img) i.loading = 'eager'; });
        $$('[data-mc-thumb]', sec).forEach(function (t) {
          var on = t.getAttribute('data-mc-thumb') === String(id);
          t.classList.toggle('is-active', on);
          if (on && tlist) {
            if (tlist.scrollHeight > tlist.clientHeight + 2) tlist.scrollTo({ top: t.offsetTop - tlist.offsetTop - 140, behavior: 'smooth' });
            else if (tlist.scrollWidth > tlist.clientWidth + 2) tlist.scrollTo({ left: t.offsetLeft - tlist.offsetLeft - 60, behavior: 'smooth' });
          }
        });
      }
      $$('[data-mc-thumb]', sec).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-mc-thumb')); }); });
      function stepMedia(d) {
        var th = $$('[data-mc-thumb]', sec); var i = th.findIndex(function (t) { return t.classList.contains('is-active'); });
        var n = th[(i + d + th.length) % th.length]; if (n) showMedia(n.getAttribute('data-mc-thumb'));
      }
      var up = $('[data-mc-tup]', sec), dn = $('[data-mc-tdown]', sec);
      if (up) up.addEventListener('click', function () { stepMedia(-1); });
      if (dn) dn.addEventListener('click', function () { stepMedia(1); });
      /* swipe on main image (mobile) */
      if (main) {
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) stepMedia(dx < 0 ? 1 : -1); sx = null; });
      }

      function paint() {
        $$('[data-mc-option]', sec).forEach(function (box) {
          var idx = Number(box.getAttribute('data-mc-option'));
          var label = $('[data-mc-opt-label]', box); if (label) label.textContent = selected[idx] || '';
          $$('[data-value]', box).forEach(function (b) {
            var val = b.getAttribute('data-value');
            var active = selected[idx] === val && (idx !== sizeIdx || sizeChosen);
            b.classList.toggle('is-active', active);
            b.setAttribute('aria-pressed', active);
            if (!b.classList.contains('mc-sw')) b.classList.toggle('is-off', !valueAvailable(product, selected, idx, val, idx === sizeIdx));
          });
        });
        var v = findVariant(product, selected);
        current = v;
        if (v) {
          idInput.value = v.id;
          priceEl.innerHTML = '<b>' + formatMoney(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '');
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? (S.add || 'Add to Bag') : (S.soldOut || 'Sold out');
          if (sizeChosen) {
            var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
          }
        } else {
          addBtn.disabled = true; addBtn.textContent = 'Unavailable';
        }
      }

      $$('[data-mc-option]', sec).forEach(function (box) {
        var idx = Number(box.getAttribute('data-mc-option'));
        $$('[data-value]', box).forEach(function (b) {
          b.addEventListener('click', function () {
            var val = b.getAttribute('data-value');
            if (b.classList.contains('is-off') && idx === sizeIdx) return;
            selected[idx] = val;
            if (idx === sizeIdx) sizeChosen = true;
            /* if combination doesn't exist, pick the first available variant with this value */
            var v = findVariant(product, selected);
            if (!v || !v.available) {
              var alt = product.variants.find(function (x) { return x.available && x.options[idx] === val; }) || product.variants.find(function (x) { return x.options[idx] === val; });
              if (alt) selected = alt.options.slice();
            }
            err.textContent = '';
            paint();
            var cv = findVariant(product, selected);
            if (cv && cv.featured_media) showMedia(cv.featured_media.id);
          });
        });
      });
      paint();

      /* show more */
      var desc = $('[data-mc-desc]', sec), more = $('[data-mc-more]', sec);
      if (desc && more) {
        requestAnimationFrame(function () {
          if (desc.scrollHeight > desc.clientHeight + 4) {
            more.hidden = false;
            more.addEventListener('click', function () {
              var open = desc.classList.toggle('is-clamped');
              more.textContent = open ? (more.getAttribute('data-more') || 'Show more') : (more.getAttribute('data-less') || 'Show less');
            });
          } else { desc.classList.remove('is-clamped'); }
        });
      }

      /* size guide -> open Size & Fit */
      var sg = $('[data-mc-sizeguide]', sec);
      if (sg) sg.addEventListener('click', function () {
        var acc = $('[data-mc-size-acc]', sec) || $$('.mc-acc details', sec).find(function (d) { return /size/i.test(d.textContent); });
        if (acc) { acc.open = true; acc.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });

      /* add to bag */
      var form = $('form[data-mc-form="product"]', sec);
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!sizeChosen) { err.textContent = S.choose || 'Please select a size'; var sb = $('[data-mc-option="' + sizeIdx + '"]', sec); if (sb) sb.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (!current || !current.available) return;
        err.textContent = '';
        addBtn.disabled = true; var t = addBtn.textContent; addBtn.textContent = '…';
        addToCart(current.id, 1).then(function () {
          if (sec.getAttribute('data-after-add') === 'cart') { window.location.href = MC.routes.cart; return; }
          addBtn.disabled = false; addBtn.textContent = t;
          refreshCount(); toast(S.added || 'Added to your bag', true);
        }).catch(function (x) { addBtn.disabled = false; addBtn.textContent = t; err.textContent = x.message || S.error; });
      });
    });
  }

  /* ---------- quick add ---------- */
  var qa;
  function closeQuick() { if (qa) { qa.classList.remove('is-open'); document.body.style.overflow = ''; } }
  function openQuick(handle) {
    fetch(root + '/products/' + encodeURIComponent(handle) + '.js').then(function (r) { return r.json(); }).then(function (p) {
      if (!qa) {
        qa = document.createElement('div'); qa.className = 'mc mc-qa'; qa.setAttribute('role', 'dialog'); qa.setAttribute('aria-modal', 'true');
        document.body.appendChild(qa);
        qa.addEventListener('click', function (e) { if (e.target.closest('[data-mc-qa-close]')) closeQuick(); });
      }
      var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      var selected = first.options.slice();
      var sizeIdx = p.options.findIndex(function (o) { return /size|مقاس|قياس|حجم/i.test(o.name || o); });
      var sizeChosen = sizeIdx === -1;
      var img = (first.featured_image && first.featured_image.src) || p.featured_image || '';
      if (img) img = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=600';
      var html = '<div class="mc-qa__bg" data-mc-qa-close></div><div class="mc-qa__box">' +
        '<button class="mc-qa__close" type="button" data-mc-qa-close aria-label="Close">&times;</button>' +
        (img ? '<img src="' + img + '" alt="">' : '<div></div>') +
        '<div><h2 class="mc-pdp__title"></h2><div class="mc-pdp__price" data-q-price></div>';
      p.options.forEach(function (o, i) {
        var name = o.name || o; var values = o.values || [];
        var isColor = /colou?r|لون|ألوان|الوان/i.test(name), isSize = /size|مقاس|قياس|حجم/i.test(name);
        html += '<div class="mc-pdp__opt" data-q-opt="' + i + '"><div class="mc-pdp__label">' + esc(name) + (isSize ? '' : ' : <em data-q-label></em>') + '</div>';
        html += '<div class="' + (isSize ? 'mc-sizes' : isColor ? 'mc-pills' : 'mc-pills') + '">';
        values.forEach(function (v) { html += '<button type="button" class="' + (isSize ? 'mc-size' : 'mc-pill') + '" data-v="' + esc(v) + '">' + esc(v) + '</button>'; });
        html += '</div></div>';
      });
      html += '<p class="mc-pdp__err" data-q-err></p><button class="mc-btn mc-btn--black" type="button" data-q-add>' + (S.add || 'Add to Bag') + '</button>' +
        '<a class="mc-qa__link" href="' + p.url + '">View full details</a></div></div>';
      qa.innerHTML = html;
      $('.mc-pdp__title', qa).textContent = p.title;
      if (p.variants.length === 1 && p.options.length === 1 && p.options[0].name === 'Title') $$('[data-q-opt]', qa).forEach(function (o) { o.remove(); });
      function paintQ() {
        $$('[data-q-opt]', qa).forEach(function (box) {
          var i = Number(box.getAttribute('data-q-opt'));
          var l = $('[data-q-label]', box); if (l) l.textContent = selected[i];
          $$('[data-v]', box).forEach(function (b) {
            var v = b.getAttribute('data-v');
            b.classList.toggle('is-active', selected[i] === v && (i !== sizeIdx || sizeChosen));
            b.classList.toggle('is-off', !valueAvailable(p, selected, i, v, i === sizeIdx));
          });
        });
        var v = findVariant(p, selected);
        var pr = $('[data-q-price]', qa);
        pr.innerHTML = v ? '<b>' + formatMoney(v.price) + '</b>' + (v.compare_at_price > v.price ? '<s>' + formatMoney(v.compare_at_price) + '</s>' : '') : '';
        var ab = $('[data-q-add]', qa); ab.disabled = !(v && v.available); ab.textContent = v && v.available ? (S.add || 'Add to Bag') : (S.soldOut || 'Sold out');
        return v;
      }
      $$('[data-q-opt]', qa).forEach(function (box) {
        var i = Number(box.getAttribute('data-q-opt'));
        $$('[data-v]', box).forEach(function (b) {
          b.addEventListener('click', function () {
            if (b.classList.contains('is-off') && i === sizeIdx) return;
            selected[i] = b.getAttribute('data-v'); if (i === sizeIdx) sizeChosen = true;
            var v = findVariant(p, selected);
            if (!v || !v.available) { var alt = p.variants.find(function (x) { return x.available && x.options[i] === selected[i]; }); if (alt) selected = alt.options.slice(); }
            $('[data-q-err]', qa).textContent = '';
            paintQ();
          });
        });
      });
      $('[data-q-add]', qa).addEventListener('click', function () {
        if (!sizeChosen) { $('[data-q-err]', qa).textContent = S.choose || 'Please select a size'; return; }
        var v = paintQ(); if (!v) return;
        var btn = this; btn.disabled = true; btn.textContent = '…';
        addToCart(v.id, 1).then(function () { closeQuick(); refreshCount(); toast(S.added || 'Added to your bag', true); })
          .catch(function (x) { $('[data-q-err]', qa).textContent = x.message || S.error; paintQ(); });
      });
      paintQ();
      qa.classList.add('is-open'); document.body.style.overflow = 'hidden';
      var c = $('.mc-qa__close', qa); if (c) c.focus();
    }).catch(function () { window.location.href = root + '/products/' + handle; });
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mc-quick]');
    if (!b) return;
    e.preventDefault();
    var vid = b.getAttribute('data-variant');
    if (vid) {
      b.disabled = true;
      addToCart(vid, 1).then(function () { refreshCount(); toast(S.added || 'Added to your bag', true); })
        .catch(function (x) { toast(x.message || S.error); })
        .then(function () { b.disabled = false; });
    } else {
      openQuick(b.getAttribute('data-mc-quick'));
    }
  });

  /* ---------- cart page ---------- */
  function initCart(scope) {
    var wrap = $('[data-mc-cart-section]', scope); if (!wrap || wrap.__mc) return; wrap.__mc = true;
    var sid = wrap.getAttribute('data-mc-cart-section');
    function rerender(cart) {
      return fetch(location.pathname + '?section_id=' + sid).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var fresh = $('[data-mc-cart]', d); var old = $('[data-mc-cart]', wrap);
        if (fresh && old) old.replaceWith(fresh);
        if (cart) setCartCount(cart.item_count);
      });
    }
    function change(line, qty) {
      var box = $('[data-mc-cart]', wrap); if (box) box.classList.add('is-busy');
      return fetch(MC.routes.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Number(qty) }) })
        .then(function (r) { return r.json(); })
        .then(function (cart) { if (cart.status) toast(cart.description || cart.message || S.error); return rerender(cart.status ? null : cart); })
        .catch(function () { location.reload(); });
    }
    wrap.addEventListener('click', function (e) {
      var q = e.target.closest('[data-mc-qty]');
      if (q) {
        var line = q.getAttribute('data-line'); var input = $('[data-mc-qty-input][data-line="' + line + '"]', wrap);
        var n = Math.max(0, Number(input.value) + Number(q.getAttribute('data-mc-qty')));
        input.value = n; change(line, n);
      }
      var r = e.target.closest('[data-mc-remove]');
      if (r) change(r.getAttribute('data-mc-remove'), 0);
    });
    wrap.addEventListener('change', function (e) {
      if (e.target.matches('[data-mc-qty-input]')) change(e.target.getAttribute('data-line'), Math.max(0, Number(e.target.value) || 0));
    });
    var noteT;
    wrap.addEventListener('input', function (e) {
      if (!e.target.matches('[data-mc-note]')) return;
      clearTimeout(noteT);
      var val = e.target.value;
      noteT = setTimeout(function () {
        fetch(root + '/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: val }) });
      }, 500);
    });
  }

  /* ---------- recommendations ---------- */
  function initReco(scope) {
    $$('[data-mc-reco]', scope).forEach(function (sec) {
      if (sec.__mc || sec.children.length) return; sec.__mc = true;
      var url = sec.getAttribute('data-url'); if (!url) return;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html;
        var fresh = $('[data-mc-reco]', d);
        if (fresh && fresh.innerHTML.trim()) { sec.innerHTML = fresh.innerHTML; wlPaint(); }
      }).catch(function () {});
    });
  }

  /* header: if the menu doesn't fit next to the logo, switch to burger menu */
  function fitHeader() {
    $$('[data-mc-header]').forEach(function (h) {
      var nav = $('.mc-nav', h); if (!nav) return;
      h.classList.remove('mc-header--compact');
      nav.style.overflow = 'hidden';
      if (getComputedStyle(nav).display !== 'none' && nav.scrollWidth > nav.clientWidth + 1) h.classList.add('mc-header--compact');
      nav.style.overflow = '';
    });
  }
  var fitT; window.addEventListener('resize', function () { clearTimeout(fitT); fitT = setTimeout(fitHeader, 120); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHeader);

  function initAll(scope) {
    fitHeader();
    initTabs(scope); initGallery(scope); initProduct(scope); initCart(scope); initReco(scope); initWishlistPage(); wlPaint();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

  /* bfcache: keep bag count correct when user navigates back */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCount(); });
})();
